import React from 'react';
import BFIT_LOGO from '../../../../assets/logo.svg';
import { useAppStateContext } from '@/shared/hooks';
import { useImmer } from 'use-immer';
import { getGeneralPath } from '@/utils/functions';

export const PageLoading = (props) => {
  const [state, setState] = useImmer({ logoUrl: BFIT_LOGO });
  const { appState } = useAppStateContext();

  React.useMemo(() => {
    const logoUrl = appState?.localData?.config?.logo;

    if (logoUrl && appState.tid) {
      setState((draft) => {
        draft.logoUrl = getGeneralPath(appState.tid) + logoUrl;
      });
    }
  }, [appState?.localData?.config?.logo]);

  return (
    <div className="h-screen flex justify-center items-center">
      <div className="flex flex-col items-center gap-4">
        <img src={state.logoUrl} alt="bfit logo" className="w-[200px]" />
        {props.text && <h4 className="text-2xl font-semibold">{props.text}</h4>}
        <div
          className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin"
          role="status"
        ></div>
      </div>
    </div>
  );
};
